export function memberUpdateAdapter(state) {
  return {
    transactionId: '',
    memberType: state.memberDetails.member.memberType,
    memberCk: state.memberDetails.member.memberCk,
    subscriberCk: state.memberDetails.member.memberCk,
    clientMemberId: state.memberDetails.member.clientMemberId,
    eyemedMemberId: state.memberDetails.member.eyemedId,
    memberFirstName: state.memberDetails.member.firstName,
    memberLastName: state.memberDetails.member.lastName,
    memberMidInitial: state.memberDetails.member.middleInitial,
    memberNameSuffix: state.memberDetails.member.suffix,
    memberDateOfBirth: state.memberDetails.member.dob,
    ssn: state.memberDetails.member.ssn,
    gender: state.memberDetails.member.gender,
    phone: state.memberDetails.member.homeAddress.phone,
    email: state.memberDetails.member.homeAddress.email,
    memberIdSource: '', // waiting for answer
    primaryAddress: {
      line1: state.memberDetails.member.homeAddress.line1,
      line2: state.memberDetails.member.homeAddress.line2,
      line3: state.memberDetails.member.homeAddress.line3,
      city: state.memberDetails.member.homeAddress.city,
      state: state.memberDetails.member.homeAddress.state,
      zip: state.memberDetails.member.homeAddress.zip,
      county: state.memberDetails.member.homeAddress.county
    },
    coverage: null,
    reportingCodes: {
      divisionCode: state.memberDetails.member.divisionCode,
      benefitOption: state.memberDetails.member.benefitOption,
      locationGroupNumber: state.memberDetails.member.locationCode,
      companyCode: state.memberDetails.member.companyCode,
      clientGroupNumber: state.memberDetails.member.clientGroupNumber,
      reportingCodes: state.memberDetails.member.reportingCodes
    },
    privacy: {
      firstName: state.memberDetails.member.privacy.firstName,
      midInitial: state.memberDetails.member.privacy.middleInitial,
      lastName: state.memberDetails.member.privacy.lastName,
      address: {
        line1: state.memberDetails.member.privacy.line1,
        line2: state.memberDetails.member.privacy.line2,
        line3: state.memberDetails.member.privacy.line3,
        city: state.memberDetails.member.privacy.city,
        state: state.memberDetails.member.privacy.state,
        zip: state.memberDetails.member.privacy.zipCode,
        country: state.memberDetails.member.privacy.country
      }
    },
    ethnicity: {
      code: state.memberDetails.member.ethnicityCode,
      description: ''
    },
    race: {
      code: state.memberDetails.member.raceCode,
      description: ''
    },
    spokenLanguage: {
      code: state.memberDetails.member.spokenLanguage,
      description: ''
    },
    writtenLanguage: {
      code: state.memberDetails.member.writtenLanguage,
      description: ''
    }
  }
}
